import DefaultMapper, { toPagingAndSorting } from 'cw-core-admin-ui/src/dataProvider/DefaultMapper';
import { stringify } from 'query-string';
import { API_BASE_PATH_ADMIN } from 'cw-core-admin-ui/src/constants';

class LoyaltyProgramMembershipMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'wallet/tx/loyalty/memberships';
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = {
			...params.filter,
			...toPagingAndSorting(params),
		};
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}?${stringify(query)}`;
	}
}

export default LoyaltyProgramMembershipMapper;
